import {assert} from 'assert-ts';
import {selectMetadataEditMetadataExpressions} from 'services/metadata/metadataEditSlice';
import {useAppSelector} from 'store/hooks';
import type {ExpressionV4} from '../types';

export const useAssertExpressionsEdit = (): ExpressionV4[] => {
  const expressions = useAppSelector(selectMetadataEditMetadataExpressions);
  return assert(expressions, 'useAsserExpressions: no expressions');
};
